module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/TOP-OF-THE-LAKE_S02.c172750.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/TOP-OF-THE-LAKE_S02.jpg
// module id = g5Wg
// module chunks = 0